const HEADLINES = [
  "Launch faster with a team that ships.",
  "Your product, live in weeks.",
  "Built for scale from day one.",
];

const FEATURES = [
  { icon: "⚡", title: "Fast by default", body: "Edge-rendered pages, 98 Lighthouse." },
  { icon: "◫", title: "Design system", body: "Tokens, components, one source of truth." },
  { icon: "↻", title: "Ship weekly", body: "Preview → review → deploy, every Friday." },
];

export function createWebDevelopmentStage() {
  const wrap = document.createElement("div");
  wrap.className = "services-stage services-stage--web reveal";
  wrap.style.setProperty("--delay", "0.18s");
  wrap.setAttribute("aria-hidden", "true");

  wrap.innerHTML = `
    <div class="services-stage__glow"></div>
    <div class="services-stage__orb services-stage__orb--a"></div>
    <div class="services-stage__orb services-stage__orb--b"></div>
    <div class="services-stage__orb services-stage__orb--c"></div>

    <div class="services-stage__window services-stage__panel">
      <div class="services-stage__chrome">
        <span class="services-stage__dot services-stage__dot--r"></span>
        <span class="services-stage__dot services-stage__dot--y"></span>
        <span class="services-stage__dot services-stage__dot--g"></span>
        <span class="services-stage__path">nova.dev / home</span>
        <span class="services-stage__live" data-live><span></span>live</span>
      </div>

      <div class="site-stage">
        <div class="site-stage__nav">
          <span class="site-stage__logo"><i></i>Nova</span>
          <span class="site-stage__links"><i></i><i></i><i></i><i></i></span>
          <span class="site-stage__nav-cta">Get started</span>
        </div>

        <div class="site-stage__hero">
          <div class="site-stage__copy">
            <span class="site-stage__pill">New · v2.4 is live</span>
            <h4 data-headline>${HEADLINES[0]}</h4>
            <p>Design, build, and ship modern web apps with a squad that owns the outcome.</p>
            <div class="site-stage__actions">
              <span class="site-stage__btn site-stage__btn--primary" data-cta>Start free</span>
              <span class="site-stage__btn">See demo</span>
            </div>
          </div>
          <div class="site-stage__art">
            <div class="site-stage__art-card">
              <span class="site-stage__art-eyebrow">Weekly signups</span>
              <strong>+38%</strong>
              <div class="site-stage__art-bars">
                <i style="--h: 38%"></i><i style="--h: 52%"></i><i style="--h: 46%"></i><i style="--h: 70%"></i><i style="--h: 64%"></i><i style="--h: 92%"></i>
              </div>
            </div>
            <div class="site-stage__art-chip">4.9 ★ · 1,284 reviews</div>
          </div>
        </div>

        <div class="site-stage__features">
          ${FEATURES.map(
            (f) => `
            <div class="site-stage__feature">
              <span class="site-stage__feature-icon">${f.icon}</span>
              <strong>${f.title}</strong>
              <small>${f.body}</small>
            </div>
          `
          ).join("")}
        </div>

        <span class="site-stage__cursor" data-cursor>
          <svg viewBox="0 0 24 24"><path d="M5 3l14 8.5-6.2 1.6L9 20z" fill="#1c242c" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/></svg>
        </span>
      </div>

      <div class="services-stage__footer">
        <span>Next.js</span>
        <span>TypeScript</span>
        <span class="services-stage__pulse" data-pulse>deploying preview</span>
      </div>
    </div>
  `;

  bindSiteRuntime(wrap);
  return wrap;
}

function bindSiteRuntime(root) {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const headline = root.querySelector("[data-headline]");
  const cta = root.querySelector("[data-cta]");
  const cursor = root.querySelector("[data-cursor]");
  const pulse = root.querySelector("[data-pulse]");
  const pulses = ["deploying preview", "preview ready", "lighthouse 98", "promoted to prod"];

  if (reduced || !cursor) return;

  let step = 0;
  let timer = null;

  // Cursor drifts to the CTA, presses it, and the headline rotates on release.
  const tick = () => {
    step += 1;
    const pressing = step % 2 === 1;
    cursor.classList.toggle("is-on-cta", pressing);
    cta.classList.toggle("is-pressed", pressing);
    if (!pressing && headline) {
      headline.classList.add("is-swapping");
      headline.textContent = HEADLINES[(step / 2) % HEADLINES.length];
      window.setTimeout(() => headline.classList.remove("is-swapping"), 450);
    }
    if (pulse) pulse.textContent = pulses[step % pulses.length];
  };

  const start = () => {
    if (timer) return;
    timer = window.setInterval(tick, 1800);
  };
  const stop = () => {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  };

  start();

  const observer = new IntersectionObserver(
    ([entry]) => (entry.isIntersecting ? start() : stop()),
    { threshold: 0.2 }
  );
  observer.observe(root);
}
